import React, { useEffect, useState } from 'react'

import { MDBModal, MDBModalBody, MDBModalHeader } from 'mdbreact';
import { firestore } from '../../../firebase'

import AuthorFollowingList from './AuthorFollowingList'

function AuthorFollowing({userId, setFollowingCount}) {

    const [following, setFollowing] = useState([])
    const [show, setShow] = useState(false)

    function toggle() {
        if (show) {
            setShow(false)
        } else {
            setShow(true)
        }
    }

    useEffect(() => {

        async function fetchFollowers() {
            try {
                const followersRef = firestore.collection("follow");
                followersRef.where("follower_id", "==", userId).onSnapshot(({docs}) => {
                    const following = docs.map(doc => {
                        return {id: doc.id, ...doc.data()}
                    })
                    console.log(following)
                    // FILTER OUT CURRENT USER FROM FOLLOWERS, cant follow oneself
                    const followingArrayFiltered = following.filter(user => {
                        console.log(user.follower_id, "!==", userId)
                        return user.follower_id !== userId
                    })
                    console.log(followingArrayFiltered, "following array filtered")
                    setFollowing(following);
                    setFollowingCount(following.length)
                })
            } catch (error) {
                
            }
        }
        fetchFollowers();

    }, [setFollowingCount, userId])

    return (
        <>
            <div className="column-small-insta" style={{cursor: "pointer"}} onClick={toggle}>
                {following.length}
                <br/>
                <span style={{color: "grey"}}>follows</span>
            </div>

            <div className="column-large-insta" style={{cursor: "pointer"}} onClick={toggle}> 
                <span style={{color: "grey"}}>follows</span> {following.length}
            </div>

            <MDBModal isOpen={show} toggle={toggle}>
                <MDBModalHeader toggle={toggle}>Følger</MDBModalHeader>
                <MDBModalBody>
                    <AuthorFollowingList following={following} setShow={setShow} />
                </MDBModalBody>
            </MDBModal>

        </>
    )

}
export default AuthorFollowing